// src/components/Header.jsx
import React, { useState, useEffect } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { BsList } from 'react-icons/bs';
import { signOut, getAuth } from 'firebase/auth';
import { useAuth } from '../context/AuthContext';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { user, userData } = useAuth();
  const navigate = useNavigate();

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const handleLinkClick = () => setMenuOpen(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  

  const handleLogout = async () => {
    try {
      await signOut(getAuth());
      navigate('/');
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
    }
  };

  return (
    <header
      id="header"
      className={`fixed-top d-flex align-items-center ${scrolled ? 'header-scrolled' : ''}`}
    >
      <div className="container d-flex justify-content-between align-items-center">
        <div className="logo d-flex align-items-center">
          <h1 className="m-0">
            <Link to="/">Smart Money</Link>
          </h1>
        </div>
        <nav id="navbar" className={`navbar ${menuOpen ? 'navbar-mobile' : ''}`}>
          <ul>
            <li>
              <NavLink to="/" className={({ isActive }) => (isActive ? "active" : "")} onClick={handleLinkClick}>
                Inicio
              </NavLink>
            </li>
            
            {user ? (
            <li>
              <NavLink to="/envios" className={({ isActive }) => (isActive ? "active" : "")} onClick={handleLinkClick}>
                Realizar Envío
              </NavLink>
            </li>
            ) : (
              <li>
                <NavLink to="/login" className={({ isActive }) => (isActive ? "active" : "")} onClick={handleLinkClick}>
                  Realizar Envío
                </NavLink>
              </li>
            )}

            <li>
              <NavLink to="/tasas" className={({ isActive }) => (isActive ? "active" : "")} onClick={handleLinkClick}>
                Tasas de Cambio
              </NavLink>
            </li>
            <li>
              <NavLink to="/contact" className={({ isActive }) => (isActive ? "active" : "")} onClick={handleLinkClick}>
                Contáctanos
              </NavLink>
            </li>
            {user ? (
              <>
              {userData && ['admin', 'superadmin'].includes(userData.role) && (
                <li>
                  <NavLink to="/admin" className={({ isActive }) => (isActive ? "active" : "")} onClick={handleLinkClick}>
                    Admin
                  </NavLink>
                </li>
              )}
              <li>
                <NavLink to="/profile" className={({ isActive }) => (isActive ? "active" : "")} onClick={handleLinkClick}>
                  Perfil
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="#" 
                  className={({ isActive }) => (isActive ? "active" : "")}
                  onClick={(e) => { 
                    e.preventDefault(); 
                    handleLogout(); 
                    handleLinkClick();
                  }}
                >
                  Cerrar Sesión
                </NavLink>
              </li>
              </>
            ) : (
              <>
                <li>
                  <NavLink to="/login" className={({ isActive }) => (isActive ? "active" : "")} onClick={handleLinkClick}>
                    Iniciar Sesión
                  </NavLink>
                </li>
              </>
            )}
            {/* <li>
              <NavLink to="/faq" className={({ isActive }) => (isActive ? "active" : "")} onClick={handleLinkClick}>
                FAQ
              </NavLink>
            </li> */}
          </ul>
          <BsList className="mobile-nav-toggle" size={24} onClick={toggleMenu} />
        </nav>
      </div>
    </header>
  );
};

export default Header;
